import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10 11.25V6.75H4.75V11.25H10ZM10 11.25V16C10 17.5 9.5 19 6 19M19 11.25V6.75H13.75V11.25H19ZM19 11.25V16C19 17.5 18.5 19 15 19" />
		<Path d="M10 6.75V11.25H4.75V6.75H10Z" fill="currentColor" stroke="none" />
		<Path d="M19 6.75V11.25H13.75V6.75H19Z" fill="currentColor" stroke="none" />
	</SVG>
);
